import { useContext, useState, useEffect } from 'react';
import PageContext from "./PageContext";
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton'; 
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import validateInputArray from '../functions/validateInputArray'; 
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation';
import applyFormat from '../functions/applyFormat';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditSignOnBonusModal = () => {
    // get context from parent
    const { 
        editSignOnBonusModal, 
        setEditSignOnBonusModal, 
        editSignOnBonusRow, 
        masterCompanyData,
        getRefreshData,  
        snackbarAlert, 
        signOnBonusConfig, 
        signOnBonusLists
    } = useContext(PageContext);
    // get http context from parent
    const {
        PUT
    } = useContext(HttpContext); 
    // initialize state
    const [values, setValues] = useState([]); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);
    const [statusChange, setStatusChange] = useState(false); 

    // event handler for values change 
    const onChange = () => {
        // determine if status has changed 
        if (values['active']['id'].toString() !== editSignOnBonusRow['active'].toString()) {
            setStatusChange(statusChange => statusChange = true); 
        }
        else {
            setStatusChange(statusChange => statusChange = false); 
        } 
    }

    // event handler for submit click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            if (!statusChange) {
                let requestValues = [{...values}]; 
                // validate input
                let checkError = validateInputArray(
                    requestValues, 
                    signOnBonusConfig,
                    dynamicValidation,
                    signOnBonusLists, 
                    snackbarAlert,  
                    error, 
                    setError, 
                    dynamicTransformation, 
                    {}
                ); 
                // exit request if error 
                if (checkError) {
                    reject(); 
                    return; 
                }
                // add mastercompanyid to request body 
                requestValues[0]['mastercompanyid'] = masterCompanyData['mastercompanyid'];
                // get oldValues to attach to request 
                let temp = {...editSignOnBonusRow}
                let oldValues = applyFormat(temp, signOnBonusConfig, signOnBonusLists, null); 
                oldValues = dynamicTransformation(oldValues, signOnBonusConfig, {}); 
                // use select function to make request 
                let response; 
                PUT('/client/signOnBonus', {
                    ...requestValues[0], 
                    oldValues: oldValues
                }).then(res => {
                    console.log(res);
                    response = res; 
                    // hide modal on success
                    setEditSignOnBonusModal(editSignOnBonusModal => editSignOnBonusModal = false);
                    // trigger success alert
                    snackbarAlert(true, 'Successfully uploaded data.', 'success');
                    // refresh CompanyDetailsPage using function from parent
                    return getRefreshData();
                }).then(res => {
                    console.log(res); 
                    // resolve on success
                    resolve(response); 
                }).catch(err => {
                    console.log(err);
                    // show alert on error
                    snackbarAlert(true, 'Error uploading data.', 'error');
                    // reject on error
                    reject(err); 
                });
            }
            else {
                // validate status input 
                if (!signOnBonusLists['active'].includes(values['active'])){
                    // show snackbar on failure
                    snackbarAlert(true, 'Invalid status input.', 'error'); 
                    reject(); 
                    return; 
                }
                // make request 
                let response; 
                PUT('/client/incentiveSetupStatus',  {
                    active: values['active']['id'], 
                    incentivesetupid: values['incentivesetupid'], 
                    mastercompanyid: masterCompanyData['mastercompanyid'], 
                    companyid: values['companyid'], 
                    oldValues: {
                        active: editSignOnBonusRow['active']
                    }
                }).then(res => {
                    console.log(res);
                    response = res; 
                    // hide modal 
                    setEditSignOnBonusModal(editSignOnBonusModal => editSignOnBonusModal = false);
                    // trigger success alert
                    snackbarAlert(true, 'Successfully uploaded data.', 'success');
                    // refresh CompanyDetailsPage using function from parent
                    return getRefreshData();
                }).then(res => {
                    console.log(res);
                    // resolve on success
                    resolve(response); 
                }).catch(err => {
                    console.log(err);
                    // show alert on error
                    snackbarAlert(true, 'Error uploading data.', 'error');
                    // reject on error
                    reject(err);
                });
            }
        }); 
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (signOnBonusConfig){
            setConfig(config => config = signOnBonusConfig); 
        }
    }, [signOnBonusConfig]); 

    // useEffect to run on editSignOnBonusRow change
    useEffect(() => {
        if (editSignOnBonusRow) {
            // default status change 
            setStatusChange(statusChange => statusChange = false); 
            // add ids to lookup values 
            let temp = {
                ...editSignOnBonusRow // destructure to pass by value 
            }; 
            temp = applyFormat(temp, signOnBonusConfig, signOnBonusLists, null); 
            // set state 
            setValues(values => values = temp); 
        }
    }, [editSignOnBonusRow]); 

    return (
        <> 
            <CCOffcanvas 
                title='Edit Sign On Bonus'
                show={editSignOnBonusModal}
                onCanvasClose={()=>setEditSignOnBonusModal(editSignOnBonusModal => editSignOnBonusModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                            {/* map DynamicPageInput over all elements of input config */}
                            {config.map((el) => 
                                el['edit'] == true &&
                                (!statusChange || el['columnid'] == 'active') ? 
                                <>
                                    <div>
                                        <DynamicPageInput 
                                            data={values} 
                                            setData={setValues} 
                                            config={el} 
                                            args={signOnBonusLists} 
                                            width={'100%'} 
                                            onChangeFunction={onChange} 
                                            showError={error[0][el['columnid']]}
                                            topAlignTypography={true}
                                        />
                                    </div>
                                </>
                                : <></>
                            )}

                        </div>
                        {/* button to submit edits to rebate setup */}
                        <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            <ButtonComponent tag={"Cancel"} 
                                    border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                    onButtonClick={()=>setEditSignOnBonusModal(editSignOnBonusModal => editSignOnBonusModal = false)}
                                />
                            <ApiRequestButton onButtonClick={onSubmitClick} />
                        </div>
                    </div>
            </CCOffcanvas>
        </>
    ); 
}

export default EditSignOnBonusModal; 